import { Flex, Text } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AVAILABLE_ON, useExperimentsState } from '~/atoms/ExperimentsState'
import { useUserState } from '~/atoms/UserState'
import { NotificationBadge } from '~/components/shared/NotificationBadge'
import Logger from '~/services/Logger'
import { Size } from '~/types/ThemeTypes'
import { isElectron } from '~/utils/common'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import { SettingToggle } from './SettingItems'
import { DefaultSettingsWrapper, SubheadingSection } from './Shared'

export const ExperimentSettings = () => {
  const { t } = useTranslation()
  const { experiments } = useExperimentsState()
  const logger = new Logger('ExperimentSettings')

  const { isInternalUser } = useUserState()

  const experimentSections = experiments
    .map((experiment) => {
      if (experiment.internalOnly && !isInternalUser) {
        return null
      }

      if (experiment.availableOn === AVAILABLE_ON.DESKTOP && !isElectron) {
        return null
      } else if (experiment.availableOn === AVAILABLE_ON.WEB && isElectron) {
        return null
      }

      return (
        <SubheadingSection key={experiment.title}>
          <Flex alignItems={'center'}>
            <Text color="fg.default" {...textStyles[textStyleKeys.Body2_Bold]}>
              {experiment.title}
            </Text>
            {experiment.badge && (
              <NotificationBadge
                count={experiment.badge?.text}
                size={Size.md}
                variant={experiment.badge?.styleVariant}
                paddingLeft=".5rem"
              />
            )}
          </Flex>
          {experiment.description && (
            <SettingToggle
              label={experiment.description}
              isChecked={experiment.enabled}
              onClick={() => {
                const newState = !experiment.enabled
                experiment.onSet(newState)
              }}
            />
          )}
          {experiment.children || null}
        </SubheadingSection>
      )
    })
    .filter((experiment) => {
      return experiment
    })

  useEffect(() => {
    experiments.forEach((experiment) => {
      if (experiment?.onLoad) {
        try {
          experiment.onLoad()
        } catch (e) {
          logger.error('Error during experiment load', e as Error | null)
        }
      }
    })
  }, [])

  return (
    <DefaultSettingsWrapper>
      {experimentSections.length > 0 ? (
        experimentSections
      ) : (
        <SubheadingSection>
          <Text textStyle="Body2" color="var(--chakra-colors-fg-muted)">
            {t('updateSettings.noExperimentsAvailable')}
          </Text>
        </SubheadingSection>
      )}
    </DefaultSettingsWrapper>
  )
}
